import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ColorState } from './types';
import { RootState } from '../../types';
import { state } from './state';

const namespaced: boolean = true;

export const color: Module<ColorState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
